module.exports = __webpack_public_path__ + "img/add-circle.ddc2c72d.svg";